import React from 'react';
import styled from 'styled-components';
import { BodyThree } from '../../../../../../styles/theme/default/typography';
import BundleProduct from './BundleProduct';

const Wrapper = styled.div`
  margin: 25px 20px 20px 20px;
  padding: 0;

  .bundle-title {
    margin-bottom: 15px;
  }
`;

function Bundle({ productData, setChangeFeaturedFabrics }) {
  const bundleProducts = productData.bundle_products;
  const isBedroomSets =
    productData?.frame?.primarySubcategory.category_id == 39;

  return (
    <Wrapper>
      <BodyThree className="bundle-title">
        {isBedroomSets ? '*' : ''}What's Included:
      </BodyThree>
      <div className="bundle-products-container">
        {bundleProducts.map((bundleProduct, i) => {
          return (
            <BundleProduct
              key={i}
              setChangeFeaturedFabrics={setChangeFeaturedFabrics}
              productData={productData}
              bundleProduct={bundleProduct}
            />
          );
        })}
      </div>
    </Wrapper>
  );
}

export default Bundle;
